import {
    CreditCardIcon,
    DocumentTextIcon,
    MapIcon,
    UserGroupIcon,
} from "@heroicons/react/24/outline";
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { HashLink } from 'react-router-hash-link';


export default function RentalPolicies() {
    const policies = [
        {
            icon: UserGroupIcon,
            title: "Eligibility",
            items: [
                "Renters must be 21+ years old.",
                "Valid driver’s license (proof required, held for at least 2 years).",
                <>
                    Valid personal auto insurance (proof required). Valid insurance includes your personal auto policy or temporary insurance from companies such as{" "}
                    <a href="https://rentalcover.com/en" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">RentalCover</a>,{" "}
                    <a href="https://bonzah.com/" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">Bonzah</a> or others.
                </>,
                "Additional drivers must meet the same criteria.",
            ],
        },
        {
            icon: CreditCardIcon,
            title: "Payment",
            items: [
                "Credit card must be in renter’s name.",
                "Cash rentals require additional documentation (utility bill, pay stub, plane ticket, etc.).",
            ],
        },
        {
            icon: DocumentTextIcon,
            title: "Rental Terms",
            items: [
                "Contracts limited to 30 days (new contract required for extensions).",
                "Rentals restricted to authorized geographic areas (see agreement).",
                "Vehicles may not be used for Uber, Lyft, or other for‑hire services.",
                "Units must be used for rental purposes only.",
            ],
        },
        {
            icon: MapIcon,
            title: "Documentation",
            items: [
                "Walk‑around inspection form required.",
                "Executed rental agreement required for all rentals.",
            ],
        },
    ];

    return (
        <>
            <section className="font-sans min-h-screen bg-gray-50">
                {/* Hero Header */}
                <div className="bg-brandBlue py-20 text-center">
                    <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
                        Full Rental Policies
                    </h1>
                    <p className="text-blue-100 max-w-2xl mx-auto text-lg mb-8">
                        Transparency matters. Please review our complete rental policies to
                        ensure a smooth and compliant rental experience.
                    </p>

                    {/* Questions Button */}
                    <HashLink
                        smooth
                        to="/#contact"
                        className="inline-block px-6 py-3 bg-white text-brandBlue font-semibold rounded shadow hover:bg-blue-100 scroll-mt-20 transition"
                    >
                        Questions? Contact Us
                    </HashLink>

                </div>



                {/* Policies Grid */}
                <div className="max-w-6xl mx-auto px-6 py-16 grid gap-8 md:grid-cols-2">
                    {policies.map((policy, i) => (
                        <div
                            key={i}
                            className="bg-white rounded-xl shadow-md p-8 hover:shadow-lg transition duration-300 border border-gray-200"
                        >
                            <div className="flex items-center mb-4">
                                <policy.icon className="w-7 h-7 text-brandBlue mr-3" />
                                <h2 className="text-xl font-semibold text-gray-800">
                                    {policy.title}
                                </h2>
                            </div>
                            <ul className="list-disc list-inside text-gray-600 space-y-2">
                                {policy.items.map((item, j) => (
                                    <li key={j}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </section>
            <Footer />
        </>
    );
}
